import React from 'react';

//import AvatarEditor from 'react-avatar-editor';
import '../css/TestimonialForm.css';
import '../css/Form.css';
import '../css/UserStyle.css'
//import EditUserInfoRow from '../components/EdirUserInfoRow';
import UserProofRow from '../components/UserProofRow';
//import EditUserSelect from '../components/UserInfoSelect';
import UserInfoRow from '../components/UserInfoRow';
import UserProofRow2 from '../components/UserProofRow2';
import { fetchUserData } from '../../../config/UserDetailsFetch';
//import { fetchUser } from '../../../config/UserDetailsPrimary';
import { NavLink } from 'react-router-dom';
import { Edit, Printer, Save, Trash2 } from 'react-feather';
import Loading from '../components/Loading';
import AvatarEditor from 'react-avatar-editor';
import { UserRegistration } from '../../../config/UserRegistration';
import UserApproveRow from '../components/UserApproveRow';
import withNavigation from '../components/WithNavigation';

//import { PDFDownloadLink, Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
//import { Document, Page, Text, View, StyleSheet } from 'react-pdf';
//import PrintProfile2 from '../components/PrintProfile';
//import { PDFViewer, PDFDownloadLink, BlobProvider } from '@react-pdf/renderer';


////import html2canvas from 'html2canvas';
//import jsPDF from 'jspdf';
//import { NavLink } from 'react-router-dom';
//import PDFDocument from '../../PDF/PDFDocument';
//import { PDFDocument3 } from '../../PDF/PDFDocument3';
//import PrintButton  from '../../PDF/CreatePDF';
//import { BlobProvider } from 'react-pdf';
//import MyDocument from '../../PDF/MyDocument';
//import ReactPDF from '@react-pdf/renderer';





class ViewProfile extends React.Component {
    constructor(props) {
        super(props);
        this.contentRef = React.createRef();
        this.state = {
            image: null,
            scale: 1,
            allowZoomOut: false,
            rotate: 0,
            position: { x: 0, y: 0 },
            preview: null,
            width: 250,
            height: 250,
            user: props.user,
            joiningDate: '',
            days: 0,
            months: 0,
            years: 0,
            resignDate: null,
            
            method: 'insert', // Assuming default method is 'insert'
            isLoading: false,
            deleteLoading: false,
            approveLoading: false,
            pdfUrls: "",
            pdfFileName: "",
            UserData:null,
            StudentData: {
                id: '',
                personal_email: '',
                mobile: '',
                name: '',
                middle_name: '',
                last_name: '',
                role: '',
                address_1: '',
                address_2: '',
                address_3: '',
                city: '',
                state: '',
                pincode: '',
                image: null,
                join_date: '',
                resign_date: '',
                id_no_1: '',
                id_type_1: null,
                pdfUrls: "",
                id_proof: '',
                id_proof_1: null,
                id_no_2: '',
                id_type_2: null,
                id_proof_2: null,
                user_type : null,
                user_level : null,
                Status:null,
                application_approve:null,
                method : '',
            },
            DatabaseImg: {
                images: null,
                pdfUrls: "",
                id_proof_1: null,
                id_proof_2: null,
            },



        };
        this.handleFileChange = this.handleFileChange.bind(this);
        //this.handlePrint = this.handlePrint.bind(this);
        this.editorRef = React.createRef();
        this.rotateInputRef = React.createRef();
        this.scaleInputRef = React.createRef();
        //this.canvasRef = React.createRef();
        this.fileInputRef = React.createRef();
        
    }



   


    calculateDuration = (joiningDate, resignDate) => {
        const joinDate = new Date(joiningDate);
        const specifiedDate = resignDate ? new Date(resignDate) : new Date();

        // Calculate the difference in milliseconds
        const diffTime = Math.abs(specifiedDate - joinDate);
        // Convert milliseconds to days
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        // Calculate years
        const years = Math.floor(diffDays / 365);
        // Calculate remaining days
        const remainingDays = diffDays % 365;

        // Calculate months based on remaining days
        const months = Math.floor(remainingDays / 30);
        // Calculate remaining days
        const days = remainingDays % 30;

        this.setState({ years, months, days });

    };
    
    fetchDatafromDB = async () => {
        //const { user } = this.props; // Extract the user prop
        const postId = localStorage.getItem('postId');
        const userType = localStorage.getItem('userType');
        const update_id = localStorage.getItem('postId');
        console.log('Post ID from local storage:', postId);
        console.log('userType : ', userType);

        try {
            if (postId) {

                this.setState({ isLoading: true });
                const data = await fetchUserData(postId, userType); // Pass only the ID to fetchUserData
                const combinedObj = { ...data[0], ...data[1] };
                //console.log('data combined :', combinedObj); 

                if (combinedObj && Object.keys(combinedObj).length > 0) {
                    
                    //console.log('Length of combinedObj:', Object.keys(combinedObj).length);
                   
                    
                    this.setState({
                        StudentData: combinedObj,
                        DatabaseImg: combinedObj,// Set StudentData state
                        UserData: combinedObj,
                        method: 'update'
                        
                        // Update method if needed
                    }, () => {
                        
                        this.setState(prevState => ({
                            StudentData: { ...prevState.StudentData, method: 'update' }
                            
                        }));
                        localStorage.removeItem('postId');
                        //const postId = '';
                        //console.log('Post ID nn: ', postId);
                        console.log('update ID : ', update_id);
                        
                        //console.log('fetched data :', this.state.StudentData);
                        const { StudentData } = this.state;
                        const joiningDate = new Date(StudentData.join_date);
                        const resignDate = StudentData.resign_date ? new Date(StudentData.resign_date) : null;
                        //const method = "insert"
                       
                        this.setState({ joiningDate, resignDate }, () => {
                            this.calculateDuration(this.state.joiningDate, this.state.resignDate);
                        });

                    });

                    console.log('Post ID nn: ', postId);

                  


                } else {
                    console.log('No data found for id:', postId); // Log the user ID
                }
            } else {
                this.setState({ method: "insert" });
                console.log('No id provided', this.state.StudentData);
                //const user_type = "Student";

                this.setState(prevState => ({
                    StudentData: { ...prevState.StudentData, method: 'insert' }
                }));


                const joiningDate = new Date();
                const resignDate = new Date();
                this.setState({ joiningDate, resignDate }, () => {
                    this.calculateDuration(this.state.joiningDate, this.state.resignDate);
                }, () => {

                    console.log('join date', this.state.join_date);

                }
                );


            }
        } catch (error) {
            console.error('Error fetching user data s:', error);
        } finally {
            this.setState({ isLoading: false });
        }



    }

    componentDidMount() {
        this.fetchDatafromDB();
    }


    handleDateChange = (event) => {
        this.setState({ joiningDate: event.target.value });

    };

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleInput = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = value === null ? '' : value;
        this.setState(prevState => ({
            StudentData: {
                ...prevState.StudentData,
                [name]: sanitizedValue
            }

        }), () => {

            //console.log('Data', this.state.StudentData);

        });

    };

    handleImageChange = (e) => {
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = () => {
            const image = reader.result;
            //console.log('newww image : ', image);
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    image: image
                }
            }), () => {
                //console.log('image changed : ',image)
                // Call updatePreview after setting the image with a slight delay
                setTimeout(() => {
                    this.updatePreview();
                }, 100);
            });
        };

        if (file && allowedTypes.includes(file.type)) {
            reader.readAsDataURL(file);
        } else {
            // Notify the user that only JPG, JPEG, and PNG files are allowed
            alert('Please select a valid image file (JPG, JPEG, or PNG).');
            // Reset the file input value to prevent selecting an invalid file
            e.target.value = null;
            // Reset the avatar image to the database image if available, otherwise set it to null


            const updated_image = this.state.DatabaseImg.images;
            const databaseImage = updated_image ? updated_image : null;
            //console.log('new image e: ', updated_image);
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    image: databaseImage
                }

            }), () => {
                //console.log('Image updatedddd:', this.state.StudentData.image);
                // Call updatePreview to reflect the change
                this.updatePreview();
            });
        }


    };

    handleFileChange = (e) => {
        const reader = new FileReader();
        const file = e.target.files[0];
        reader.onload = () => {
            const file_pdf = reader.result;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    id_proof_1: file_pdf
                }
            }), () => {
                //console.log('dataaa changed : ', this.state.StudentData)

            });
        };

        if (file && file.type === 'application/pdf' && file.size <= 1500000) {
            reader.readAsDataURL(file);
        } else {

            alert('Please select a PDF file with a size below 1.5MB.');

            e.target.value = null;
           // const reader = new FileReader();

            const updated_Pdf = this.state.DatabaseImg.id_proof_1;
            const databasePdf = updated_Pdf ? updated_Pdf : null;

            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    id_proof_1: databasePdf
                }

            }), () => {

                //console.log('dataaa revert : ', this.state.StudentData)
            });

        }
    };

    /* previewPDF = (file) => {
         const reader = new FileReader();
         reader.onload = () => {
             const pdfFile = reader.result;
             this.setState(prevState => ({
                 StudentData: {
                     ...prevState.StudentData,
                     id_proof_1: pdfFile
                 }
             }));
         };
         //console.log("ddd : ", this.state.StudentData)
         //console.log("eee : ", this.state.DatabaseImg)
         reader.readAsDataURL(file);
     };*/

    handleFileChange2 = (e) => {
        const reader = new FileReader();
        const file = e.target.files[0];
        reader.onload = () => {
            const file_pdf = reader.result;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    id_proof_2: file_pdf
                }
            }), () => {
                //console.log('dataaa changed : ', this.state.StudentData)

            });
        };

        if (file && file.type === 'application/pdf' && file.size <= 1500000) {
            reader.readAsDataURL(file);
        } else {

            alert('Please select a PDF file with a size below 1.5MB.');

            e.target.value = null;

            const updated_Pdf = this.state.DatabaseImg.id_proof_2;
            const databasePdf = updated_Pdf ? updated_Pdf : null;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    id_proof_2: databasePdf
                }

            }), () => {
                //console.log('dataaa revert : ', this.state.StudentData)
            });
        }
    };

    handleFileChangeApprove = (e) => {
        const reader = new FileReader();
        const file = e.target.files[0];
        reader.onload = () => {
            const file_pdf = reader.result;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    application_approve: file_pdf
                }
            }), () => {
                //console.log('dataaa changed : ', this.state.StudentData)

            });
        };

        if (file && file.type === 'application/pdf' && file.size <= 1500000) {
            reader.readAsDataURL(file);
        } else {

            alert('Please select a PDF file with a size below 1.5MB.');

            e.target.value = null;

            const updated_Pdf = this.state.DatabaseImg.application_approve;
            const databasePdf = updated_Pdf ? updated_Pdf : null;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    application_approve: databasePdf
                }

            }), () => {
                //console.log('dataaa revert : ', this.state.StudentData)
            });
        }
    };



    openPDFInNewTab = (pdfUrl) => {
        const newWindow = window.open('', '_blank');
        newWindow.document.title = 'PDF Viewer';
        newWindow.document.write(`<embed width="100%" height="100%" src="${pdfUrl}">`);
        //console.log('Opened PDF in new tab:', pdfUrl);
    };

    openPDFInNewTab2 = (pdfUrl) => {
        const newWindow = window.open('', '_blank');
        newWindow.document.title = 'PDF Viewer';
        newWindow.document.write(`<embed width="100%" height="100%" src="${pdfUrl}">`);
        //console.log('Opened PDF in new tab:', pdfUrl);
    };

    openPDFTab =(pdfUrl)=>{
        console.log('Opening PDF:', pdfUrl);
        const url = `https://yesedacademy.com/database/${pdfUrl}`;
        window.open(url, '_blank');

    }


    handleZoomIn = () => {
        this.setState((prevState) => ({ scale: Math.min(prevState.scale + 0.1, 8) }), () => {
            this.updatePreview();
        });

    };

    handleZoomOut = () => {
        this.setState((prevState) => ({ scale: Math.max(prevState.scale - 0.1, 1) }), () => {
            this.updatePreview();
        });
    };

    handleXPosition = (e) => {
        const x = parseFloat(e.target.value);
        this.setState({ position: { ...this.state.position, x } }, () => {
            this.updatePreview();
        });
    };

    handleYPosition = (e) => {
        const y = parseFloat(e.target.value);
        this.setState({ position: { ...this.state.position, y } }, () => {
            this.updatePreview();
        });
    };

    setEditorRef = editor => {
        if (editor) {
            this.editor = editor;
            this.updatePreview();
        }
    }

    handlePositionChange = position => {
        this.setState({ position });
    }

    rotateLeft = (e) => {
        e.preventDefault();
        this.setState({
            rotate: this.state.rotate - 90
        },
            () => {
                this.updatePreview(); // Call updatePreview after rotating left
            }
        );
    }

    rotateRight = (e) => {
        e.preventDefault();
        this.setState({
            rotate: this.state.rotate + 90
        },
            () => {
                this.updatePreview();
            }
        );
    }

    handleScale = (e) => {
        const scale = parseFloat(e.target.value);
        this.setState({ scale }, () => {
            this.updatePreview();
        });
    }

    handleRotateChange = (e) => {
        const rotate = parseFloat(e.target.value);
        this.setState({ rotate }, () => {
            this.updatePreview();
        });
    };


    updatePreview = () => {

        const img = new Image();
        img.src = this.editor.getImageScaledToCanvas().toDataURL();

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0);

            const jpgImage = canvas.toDataURL('image/jpeg', 0.8);
            //console.log("image :" ,  );

            this.setState({
                preview: {
                    img: jpgImage,
                    scale: this.state.scale,
                    width: 250,
                    height: 250,
                }
            });
        };
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        console.log('handle submit called');
    
        const formData = new FormData();
        formData.append('StudentData', JSON.stringify(this.state.StudentData));
    
        try {
            console.log('Student data trying to insert');
            console.log('handle submit data : ', formData);
            const response = await UserRegistration(this.state.StudentData);
    
            if (response.ok) {
                // Handle successful insertion
                console.log('handle submit data : ', formData);
                console.log('Student data inserted successfully!');
            } else {
                // Handle insertion failure
                console.error('Failed to insert student data.');
            }
        } catch (error) {
            console.error('Error inserting student data:', error);
        }
    };


    handleSave = () => {
        
        console.log('Save button clicked');
      };

      handleEdit = () => {
        
        console.log('Edit button clicked');
        localStorage.setItem('postId', this.state.StudentData.id);
        localStorage.setItem('userType', this.state.StudentData.user_type);
        console.log('User Type:', this.state.StudentData.user_type);
        console.log('User ID:', this.state.StudentData.id);
      };


/*

handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    const form = e.target;
    

        // Open a new tab with the form submission URL
        window.open(form.action, '_blank');
        
}
*/
handleApprove = () => {
    this.setState({ isApproved: true });
  };

  handleCancel = () => {
    this.setState({ isApproved: false });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = ''; // Clear the file input
    }
    this.setState(prevState => ({
      StudentData: {
        ...prevState.StudentData,
        application_approve: '' // Reset the application_approve in state
      }
    }));
  };

  /*handleDelete = (event) => {
    // Prevent the default form submission
    event.preventDefault();

    // Show a confirmation dialog
    const userConfirmed = window.confirm('Are you sure you want to delete your profile? This action cannot be undone.');

    // If the user confirms, submit the form
    if (userConfirmed) {
        document.getElementById('delete_profile').submit();
    }
};*/


handleDelete = async () => {
    if (this.state.deleteLoading) {
        return;
      }

    const userConfirmed = window.confirm('Are you sure you want to delete this user? This action cannot be undone.');
  
    if (userConfirmed) {
      this.setState({ deleteLoading: true });
  
      try {
        const response = await fetch('https://yesedacademy.com/database/userDelete.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.state.StudentData)
        });

        const result = await response.json();
        console.log("Response : ", result);

        if (result.status === 'success') {
          this.setState({ deleteLoading: false });
          alert(result.message);
          this.state.StudentData.user_type == "Student" ? this.props.navigate('/students/list') : this.props.navigate('/employee/list');
          //window.location.href = '/view-reviews';
          // handle success (e.g., redirect or update UI)


        } else {
          this.setState({ deleteLoading: false });
          alert(result.message);
          // handle error (e.g., display error message)
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
        this.setState({ deleteLoading: false });
        alert('Failed to delete the user. Please try again later.');
      }
    }
  };
  

handleApproved = async(event) => {
    // Prevent the default form submission
    event.preventDefault();
    if (this.state.approveLoading) {
        return;
      }


    // Show a confirmation dialog
    const userConfirmed = window.confirm('Are you sure you want to approve this profile? This action cannot be undone.');

    // If the user confirms, submit the form
    if (userConfirmed) {
        this.setState({ approveLoading: true });

        try {
            const response = await fetch('https://yesedacademy.com/database/userApprove.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(this.state.StudentData)
            });
    
            const result = await response.json();
            console.log("Response : ", result);
    
            if (result.status === 'success') {
              this.setState({ approveLoading: false });
              alert(result.message);
              localStorage.setItem('postId', this.state.StudentData.id);
            localStorage.setItem('userType', this.state.StudentData.user_type);
            this.fetchDatafromDB();
              this.state.StudentData.user_type == "Student" ? this.props.navigate(`/students/view-profile/${this.state.StudentData.id}`) : this.props.navigate(`/employee/view-profile/${this.state.StudentData.id}`);
              this.setState({ isApproved: false });
              //window.location.href = '/view-reviews';
              // handle success (e.g., redirect or update UI)
    
    
            } else {
              this.setState({ approveLoading: false });
              alert(result.message);
              // handle error (e.g., display error message)
            }
          } catch (error) {
            console.error('Failed to fetch:', error);
            this.setState({ approveLoading: false });
            alert('Failed to delete the user. Please try again later.');
          }
        
    }
};

isBase64(str) {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  }

  

    render() {

        const { StudentData, UserData, isLoading, deleteLoading, approveLoading } = this.state;
        const { joiningDate, resignDate, years, months, days } = this.state;
        let duration;

        if (years > 0) {
            duration = `${years} year${years > 1 ? 's' : ''}, ${months} month${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
        } else if (years === 0 && months > 0) {
            duration = `${months} month${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
        } else {
            duration = `${days} day${days > 1 ? 's' : ''}`;
        }

       // const { id, personal_email, mobile, name, middle_name, last_name, role, address_1, address_2, address_3, city, state, pincode, image, join_date, resign_date, id_no_1, id_type_1, id_proof_1, id_no_2, id_type_2, id_proof_2 } = this.state.StudentData;

        //const { images } = this.state.DatabaseImg;

       // const { pdfUrls, pdfFiles } = this.state;
        const { postId } = this.props;

        const update_id = localStorage.getItem('postId');
        console.log("ppp ID : ",postId);
        console.log("upp ID :",update_id);
        console.log("RDate :",this.state.StudentData.resign_date);
        console.log("Application :",this.state.StudentData.application_approve);
        
        const { user } = this.props;

        
        


        return (


            <div>
                {isLoading ? (
                    <Loading size={100} />
                ) : UserData ? (
                  <div>
                    <div className="container" >
                        <div className="row mt-2" >
                            <div className="col-md-9">
                                {StudentData.Status === 'In Process' ?  !this.state.isApproved && (<div className="col-md-5" ><button className='y-hover' type="button" onClick={this.handleApprove}> Approve </button></div>):''}
                            
                            <div className="col-md-7">{this.state.isApproved && <div>
                                {approveLoading ? <span><Loading size={20} /></span> :
                                <>
                                <span><UserApproveRow type="file" id="app_approve" onChange={this.handleFileChangeApprove}
                                            value={StudentData.application_approve}
                                            
                                            onClick={() => this.openPDFInNewTab(StudentData.application_approve)} inputRef={this.fileInputRef} />
                                            <button className='y-hover' id="approve_pro" name="approve_pro"  type='submit' onClick={this.handleApproved}> Approve </button> 
                                            <button className='y-hover' type="button" onClick={this.handleCancel}>Cancel </button></span> 
                                            </>
    }

                                            </div>} </div>
                            </div>
                           { user !== this.state.StudentData.email_address &&  <div className="col-md-9">
                           
                                   <div className="d-flex justify-content-start align-items-center ">
                                   {deleteLoading ? <span><Loading size={20} /></span> :
                                   <button className='no-hover'  id="del" name="del"  type='submit' onClick={this.handleDelete} ><Trash2 className='ico-button' />Delete</button>
                                  
                }

                                   </div>
                          
                                   </div>
                }
                           
                                   <div className="col-md-3">
                                   <div className="d-flex justify-content-start align-items-center ">
                                   <div><NavLink to={StudentData.user_type==='Student'?`/students/edit-profile/${StudentData.id}`:`/employee/edit-profile/${StudentData.id}`} label='Edit'><button className='no-hover' onClick={this.handleEdit}><Edit className='ico-button' aria-label="Edit" />Edit</button></NavLink></div>
                                   
                                   <span className='p-3'>  </span>
                                   <div>
                                    <form id="create_pdf" name="create_pdf" action="https://yesedacademy.com/database/mpdf/test_pdf.php" method="post" encType="multipart/form-data" target="_blank">
                                    <button className='no-hover'  id="insert" name="insert"  type='submit'  ><Printer className='ico-button' />Print</button>
                                    <input type="text" name="user_id" id="user_id" hidden value={StudentData.id}/>
                                    <input type="text" name="user_type" id="user_type" hidden value={StudentData.user_type}/>
                                    </form>
                                    </div>
                                    </div>
                                    </div>
                                   </div>
                                   </div>

                        <div className="container rounded bg-white " >
                            <div className="row" >
                                <div className="col-md-15 border-right" >
                                    <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                                    <img className="rounded-circle mt-5" width="150px" src={`https://yesedacademy.com/database/${StudentData.image}`} alt='profile_img' />
                                <span className="font-weight-bold">{StudentData.name}</span>
                                <span className="text-black-50">{StudentData.role}</span>
                                <span> </span>

                                



                                    </div>

                                </div>
                                
                                <div className="col-md-16 border-right" >
                                    <div className="p-3 py-5">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h4 className="text-right">Personal Information </h4>
                                        </div>
                                        <UserInfoRow label="Full Name" value={`${StudentData.name} ${StudentData.middle_name} ${StudentData.last_name}`} />

                                        <UserInfoRow label="Email" value={StudentData.personal_email}  />
                                        <UserInfoRow label="Mobile *" value={`+${StudentData.mobile_ISD} ${StudentData.mobile}`}  />
                                        <UserInfoRow label="Address" value={StudentData.address_1}  />
                                        <UserInfoRow value={StudentData.address_2}  />
                                        <UserInfoRow  value={StudentData.address_3}  />
                                        <UserInfoRow label="City" value={StudentData.city}  />
                                        <UserInfoRow label="State" value={StudentData.state}  />
                                        <UserInfoRow label="Pincode" value={StudentData.pincode}  />

                                    </div>
                                    
                                </div>
                                <div className="col-md-17">
                                
                                
                                    <div className="p-3 py-5">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h4 className="text-right">Job Information</h4>
                                        </div>
                                        <UserInfoRow label={StudentData.Status === 'In Process' ? "Application ID" : "Enroll ID "} value={`YES${new Date().getFullYear()}.OET.${StudentData.id}`}   />
                                        <UserInfoRow label="Role " value={StudentData.role}  />
                                        <UserInfoRow label="Email " value={StudentData.email_address} />
                                        <UserInfoRow label="Date of Joining " value={joiningDate ? joiningDate.toDateString() : ""}  />
                                        <UserInfoRow label="Resigned Date" value={resignDate ? resignDate.toDateString() : ""} />
                                        <UserInfoRow label="Duration" value={duration} />


                                        {resignDate !== "" ? <div> <UserInfoRow label="Status" value="Resigned" /></div> : <UserInfoRow label="Status" value="Currently Employed" />}
                                        <UserInfoRow label="Application Status " value={StudentData.Status}  />
                                    </div>
                                   
                                </div>
                            </div>
                   </div>

                        <div className="container  " >
                            <div className="row" >
                                <div className="col-md-15 border-right" >
                                <div className="p-3 py-5 mt-10">
                                    
                                    <UserProofRow2 value={StudentData.approved_application} onClick={() => this.openPDFTab(StudentData.approved_application)} />
                                    </div>

                                </div>
                                
                                <div className="col-md-16 border-right" >
                                    <div className="p-3 py-5">
                                        
                                   
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h4 className="text-right">Personal Information </h4>
                                        </div>
                                        <div><UserInfoRow label="Identity Proof 1" style={{ fontWeight: 'bold' }} />
                                        <UserInfoRow label="ID Proof Type" value={StudentData.id_type_1} />
                                        <UserInfoRow label="ID Proof Number" value={StudentData.id_no_1}  />
                                        <UserProofRow value={StudentData.id_proof_1} onClick={() => this.openPDFTab(StudentData.id_proof_1)} />
</div>
</div>
                                </div>
                                <div className="col-md-17">
                                
                                
                                    <div className="p-3 py-5 mt-10">
                                    
                                        
                                        <UserInfoRow label="Identity Proof 2" style={{ fontWeight: 'bold' }} />
                                        <UserInfoRow label="ID Proof Type"  value={StudentData.id_type_2}  />
                                        <UserInfoRow label="ID Proof Number" value={StudentData.id_no_2}  />
                                        <UserProofRow value={StudentData.id_proof_2} onClick={() => this.openPDFTab(StudentData.id_proof_2)} />
                                        




                                    </div>
                                </div>
                            </div>
                            <input type="text" name="actionToPerform" id="actionToPerform" hidden value={this.state.StudentData.method}/>
                            <input type="text" name="user_type" id="user_type" hidden value={this.state.StudentData.user_type}/>
                            <input type="text" name="user_level" id="user_level" hidden value={this.state.StudentData.user_level}/>
                            <input type="text" name="id_proof_1" id="id_proof_1" hidden value={this.state.StudentData.id_proof_1}/>
                            <input type="text" name="id_proof_2" id="id_proof_2" hidden value={this.state.StudentData.id_proof_2}/>

                        </div>
                        
                       </div>
                   
                ) : (
                    <p>No data available</p>
                )}

            </div>
            


        );
    }
}

export default withNavigation(ViewProfile);
